import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FaEdit, FaTrashAlt } from 'react-icons/fa'
import { useSelector } from 'react-redux'

import { useGetCategoryAccessPoliciesQuery } from '../../../api/services/categoryAccessPolicyApi'
import CreateCategoryAccessPolicyModal from '../../modals/companies/policies/CreateCategoryAccessPolicyModal'
import DeleteCategoryAccessPolicyModal from '../../modals/companies/policies/DeleteCategoryAccessPolicyModal'
import UpdateCategoryAccessPolicyModal from '../../modals/companies/policies/UpdateCategoryAccessPolicyModal'
import { Button } from '../../root/Button'
import ColumnFilter from '../ColumnFilter'
import Table from '../Table'

const TableCategoryAccessPolicies = () => {
  const { t } = useTranslation()
  const company = useSelector((state) => state.company.company)

  const [openCreate, setOpenCreate] = useState(false)
  const [openUpdate, setOpenUpdate] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)
  const [selectedPolicy, setSelectedPolicy] = useState(null)
  const [deletePolicyId, setDeletePolicyId] = useState(null)

  const { data: policies } = useGetCategoryAccessPoliciesQuery(company?.id, {
    skip: !company?.id,
  })

  const columns = useMemo(
    () => [
      {
        Header: t('name'),
        accessor: 'name',
        Filter: ColumnFilter,
      },
      {
        Header: t('allowed_categories'),
        accessor: 'categoryNames',
        Filter: ColumnFilter,
      },
    ],
    [t],
  )

  const data = useMemo(() => (Array.isArray(policies) ? policies : []), [policies])

  const tableHooksArray = [
    {
      label: t('edit'),
      Icon: FaEdit,
      onClick: (row) => {
        setSelectedPolicy(row.original)
        setOpenUpdate(true)
      },
      disabled: false,
    },
    {
      label: t('delete'),
      Icon: FaTrashAlt,
      onClick: (row) => {
        setDeletePolicyId(row.original.id)
        setOpenDelete(true)
      },
      disabled: false,
    },
  ]

  return (
    <div className="wrapper phone:hidden mt-2 flex flex-col gap-4">
      <h2 className="font-popins font-semibold text-lg text-[#073C59]">{t('category_access_policies')}</h2>
      <div className="w-full flex justify-start">
        <div className="w-full max-w-xs">
          <Button onClick={() => setOpenCreate(true)}>{t('create_policy')}</Button>
        </div>
      </div>

      <Table data={data} columns={columns} actions filtering hooksArray={tableHooksArray} />

      <CreateCategoryAccessPolicyModal open={openCreate} onClose={() => setOpenCreate(false)} />
      <UpdateCategoryAccessPolicyModal
        open={openUpdate}
        onClose={() => setOpenUpdate(false)}
        policy={selectedPolicy}
      />
      <DeleteCategoryAccessPolicyModal
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        policyId={deletePolicyId}
      />
    </div>
  )
}

export default TableCategoryAccessPolicies
